/* eslint-disable graphql/template-strings */
/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import * as apollo from 'apollo-link';
import { gql } from 'graphql-tag';
import { filter, first } from 'rxjs/operators';
import {
  ConnextData,
} from '..';

import { GraphqlApiService } from '../../graphql-api/graphql-api.service';

export interface GetConnextDataInput {
  id: string;
}
const build = (_query: DocumentNode, input: GetConnextDataInput, name = 'QueryResult') => {
  const bQuery = `
  query ${ name }(`+
    ( input.id !== undefined ? `$id: String = ${JSON.stringify(input.id).replace(/"(\w+)":/g, '$1:')}` : '' ) + `){
    getConnextData(
      ${ input.id !== undefined ? 'id: $id,' : '' }
    ){
      ...connextdata
    }
  }`;
  return gql`
  ${bQuery}
  ${_query}
`};

@Injectable({
  providedIn: 'root',
})
export class GetConnextDataQuery {
  readonly graphqlClient$ = this.graphqlApiService.client$.pipe(
    filter((available) => !!available),
  );

  readonly build = build;

  constructor(
    private readonly graphqlApiService: GraphqlApiService,
  ) { }

  /**
   * fragment connextdata on ConnextData { ... }
   */
  async execute(_query: DocumentNode, input: GetConnextDataInput, refresh = false) {
    const client = await this.graphqlClient$.pipe(first()).toPromise();
    if (!client) {
      throw Error('Missing graphql client!');
    }
    const fetchPolicy = refresh ? 'network-only' : 'cache-first';
   return await client?.query<{ getConnextData: Partial<ConnextData> }>({ query: build(_query, input), fetchPolicy });
  }
}
